import styled, { css } from 'styled-components';

export const Wrap = styled.div`
  background-color: #ffff;
  border-radius: 4px;
  box-shadow: 0 0 1px #eaeaea inset;
  padding: 25px;
  min-height: 200px;
  width: 87%;

  button {
    margin: 25px 0 0 0;
    font-size: 12px;
  }
`;

export const Header = styled.div`
  display: flex;
  position: relative;
  margin-bottom: 10px;
`;

export const Title = styled.div`
  font-size: 16px;
  font-weight: 700;
  max-width: 317px;
  color: #2c2c2c;
`;

export const LastUpdate = styled.div`
  position: absolute;
  font-size: 12px;
  right: 0;
  color: #8e8e8e;
  font-style: italic;
`;

export const ListHeader = styled.div`
  display: flex;
  position: relative;
  border-bottom: 1px solid #eaeaea;
  margin-bottom: 10px;
  padding-bottom: 5px;
  color: #8e8e8e;
  font-size: 12px;
  font-weight: 300;
`;

export const HProject = styled.div``;

export const HDays = styled.div`
  position: absolute;
  right: 0;
`;

export const Projects = styled.div``;

export const Project = styled.div`
  margin: 11px 0;
  padding-left: 8px;
  border-left: 4px solid ${({ color, days }) => (days <= 2 ? '#e34850' : color)};
  display: flex;
  position: relative;
`;

export const ProjectInfo = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${({ overdue }) =>
    overdue &&
    css`
      ._spectrum-BarLoader-label_c74d2 {
        color: #e34850;
        font-style: italic;
      }
    `}

  ._spectrum-BarLoader-label_c74d2 {
    margin-bottom: 4px;
  }

  ._spectrum-BarLoader-percentage_c74d2 {
    margin-bottom: 4px;
    color: #8e8e8e;
  }
`;

export const ProjectTitle = styled.div`
  font-weight: bold;
  color: #2c2c2c;
  font-size: 14px;
  margin-bottom: 6px;
  max-width: 80%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ProjectDaysLeft = styled.div`
  position: absolute;
  right: 0;
  font-size: 18px;
  margin-right: 16px;
  color: #2c2c2c;
`;
